module.exports = __webpack_public_path__ + "static/investment-0826b1d80114f927e203e33e03331c14.png";